import gql from "graphql-tag";

export const SUBSCRIBE_VENDORS_COUNT = gql`
subscription vendorsCount($search: String!){
  vendorsCount: Vendors_aggregate (where:{_and: [{deleted_at :{_is_null: true}}, {_or: [{name: {_ilike: $search}}, {vendorCode: {_ilike: $search}}, {city: {_ilike: $search}}, ]}]}){
    aggregate{ count }
  }
}`

export const SUBSCRIBE_VENDORS = gql`
subscription vendors($offset: Int!, $limit: Int!, $search: String!, $orderBy: [Vendors_order_by!]){
  Vendors (where:{_and: [{deleted_at :{_is_null: true}}, {_or: [{name: {_ilike: $search}}, {vendorCode: {_ilike: $search}}, {city: {_ilike: $search}} ]}]}, offset: $offset, limit: $limit, order_by: $orderBy){
    id   
    name
    vendorCode
    profileImage    
    city
    transportation
    bankName
    accountName
    accountNumber
    ifscCode
    created_at
  }
}`